import { TextArea } from '@nike/eds';
import { useState } from 'react';
import { RANKING_RULE_TARGET_TYPES } from '../../constants/index';
import FileUploader from '../FileUploader';
import { processCommaSeparatedStringValues } from '../../utils/rankingRuleHelpers';

export default function TargetStyleColorForm({
  validationError,
  onActionItemsChange,
}: {
  validationError: string;
  onActionItemsChange: (
    items: RankingRuleTargetBoostItem[] | RankingRuleTargetBuryItem,
  ) => void;
}) {
  const [textValue, setTextValue] = useState('');

  const handleItemsChange = (textValue: string) => {
    if (textValue && textValue.length > 0) {
      const styleColors = processCommaSeparatedStringValues(textValue);
      const items = styleColors.map((sc) => ({
        type: RANKING_RULE_TARGET_TYPES.STYLE_COLOR,
        value: sc,
        relation: 'eq',
      }));
      onActionItemsChange(items);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { target } = event;
    const val = (target as HTMLTextAreaElement).value;
    setTextValue(val);
    handleItemsChange(val);
  };

  const handleFileUpload = (files: FileList | null) => {
    if (!files) return;

    const reader = new FileReader();
    reader.onload = ({ target }) => {
      setTextValue(target?.result as string);
      handleItemsChange(target?.result as string);
    };
    reader.readAsText(files[0]);
  };
  return (
    <div className='tw-my-2 tw-mt-3'>
      <TextArea
        minRows={3}
        id='product-ranking-rule'
        hideLabel
        label='Product Ranking Rule'
        className='tw-w-full tw-mb-2'
        placeholder='Enter StyleColors here, seperate by comma or new line'
        value={textValue}
        onChange={handleChange}
        errorMessage={validationError}
        hasErrors={!!validationError}
      />
      <FileUploader onFileUpload={handleFileUpload} />
    </div>
  );
}
